import React, { useState } from 'react';

const STYLES = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');
@import url('https://api.fontshare.com/v2/css?f[]=clash-display@400,500,600,700&display=swap');
:root{--navy:#06112b;--navy2:#0d1f45;--navy3:#112359;--blue:#1c73ba;--blue2:#2b8de0;--blue3:#5aaef7;--gold:#f5a623;--gold2:#ffc94d;--muted:#94a3b8;--border:rgba(28,115,186,0.15);}
.fls-page{min-height:100vh;background:linear-gradient(145deg,var(--navy) 0%,var(--navy3) 60%,#1a3570 100%);font-family:'DM Sans',sans-serif;color:#fff;overflow-x:hidden;}
.fls-page::before{content:'';position:fixed;inset:0;background-image:linear-gradient(rgba(28,115,186,0.05) 1px,transparent 1px),linear-gradient(90deg,rgba(28,115,186,0.05) 1px,transparent 1px);background-size:52px 52px;pointer-events:none;z-index:0;}
.fls-nav{position:sticky;top:0;z-index:50;display:flex;align-items:center;justify-content:space-between;padding:0 5%;height:68px;background:rgba(6,17,43,0.9);backdrop-filter:blur(20px);border-bottom:1px solid var(--border);}
.fls-logo{font-family:'Clash Display',sans-serif;font-size:1.5rem;font-weight:700;color:#fff;text-decoration:none;}
.fls-logo span{color:var(--gold);}
.fls-back{background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.12);border-radius:8px;padding:7px 14px;color:rgba(255,255,255,0.75);font-size:0.85rem;cursor:pointer;text-decoration:none;transition:background 0.2s;}
.fls-back:hover{background:rgba(255,255,255,0.12);color:#fff;}
.fls-hero{padding:72px 5% 48px;position:relative;z-index:1;max-width:1200px;margin:0 auto;display:grid;grid-template-columns:1fr 1fr;gap:56px;align-items:center;}
@media(max-width:860px){.fls-hero{grid-template-columns:1fr;gap:32px;}}
.fls-eyebrow{display:inline-flex;align-items:center;gap:8px;background:rgba(245,166,35,0.12);border:1px solid rgba(245,166,35,0.3);border-radius:99px;padding:5px 14px;font-size:0.72rem;font-weight:700;color:var(--gold);letter-spacing:2px;text-transform:uppercase;margin-bottom:20px;}
.fls-eyebrow-dot{width:6px;height:6px;border-radius:50%;background:var(--gold);animation:flsPulse 2s infinite;}
@keyframes flsPulse{0%,100%{box-shadow:0 0 0 0 rgba(245,166,35,0.4);}50%{box-shadow:0 0 0 5px rgba(245,166,35,0);}}
.fls-h1{font-family:'Clash Display',sans-serif;font-size:clamp(2rem,3.5vw + 0.5rem,3.2rem);font-weight:700;line-height:1.1;margin-bottom:16px;}
.fls-h1 em{font-style:normal;color:var(--blue3);}
.fls-sub{font-size:1rem;color:rgba(255,255,255,0.6);line-height:1.7;max-width:460px;margin-bottom:28px;}
.fls-img-wrap{border-radius:22px;overflow:hidden;background:rgba(13,31,69,0.6);border:1px solid rgba(28,115,186,0.2);aspect-ratio:4/3;display:flex;align-items:center;justify-content:center;box-shadow:0 20px 60px rgba(0,0,0,0.4);}
.fls-img{width:100%;height:100%;object-fit:contain;padding:32px;transition:transform 0.4s;}
.fls-img-wrap:hover .fls-img{transform:scale(1.04);}
.fls-body{padding:40px 5% 80px;position:relative;z-index:1;max-width:1200px;margin:0 auto;}
.fls-grid{display:grid;grid-template-columns:1fr 380px;gap:40px;align-items:start;}
@media(max-width:860px){.fls-grid{grid-template-columns:1fr;}}
.fls-section-label{display:block;font-size:0.72rem;font-weight:700;letter-spacing:2.5px;text-transform:uppercase;color:var(--blue3);margin-bottom:12px;}
.fls-section-heading{font-family:'Clash Display',sans-serif;font-size:clamp(1.5rem,2.5vw,2.2rem);font-weight:700;color:#fff;line-height:1.15;margin-bottom:8px;}
.fls-section-heading em{font-style:normal;color:var(--gold);}
.fls-order{background:rgba(255,255,255,0.03);border:1px solid rgba(28,115,186,0.2);border-radius:20px;padding:28px;position:relative;overflow:hidden;backdrop-filter:blur(16px);}
.fls-order::before{content:'';position:absolute;top:-30%;right:-30%;width:60%;height:60%;background:radial-gradient(circle,rgba(245,166,35,0.06) 0%,transparent 70%);pointer-events:none;}
.fls-price{font-family:'Clash Display',sans-serif;font-size:2.2rem;font-weight:700;color:var(--gold);line-height:1;margin-bottom:4px;}
.fls-price-sub{font-size:0.8rem;color:var(--muted);margin-bottom:20px;}
.fls-mat-row{display:flex;gap:8px;margin-bottom:20px;flex-wrap:wrap;}
.fls-mat-btn{padding:9px 20px;border-radius:99px;border:1px solid var(--border);background:transparent;color:rgba(255,255,255,0.6);font-family:'DM Sans',sans-serif;font-size:0.82rem;font-weight:600;cursor:pointer;transition:all 0.2s;}
.fls-mat-btn.active{background:rgba(28,115,186,0.2);border-color:var(--blue);color:#fff;}
.fls-mat-btn:hover:not(.active){border-color:rgba(28,115,186,0.35);color:#fff;}
.fls-stepper{display:flex;align-items:center;gap:0;background:rgba(255,255,255,0.05);border:1px solid var(--border);border-radius:10px;overflow:hidden;margin-bottom:20px;width:fit-content;}
.fls-stp-btn{width:42px;height:42px;background:transparent;border:none;color:var(--blue3);font-size:1.2rem;cursor:pointer;transition:background 0.2s;}
.fls-stp-btn:hover{background:rgba(28,115,186,0.15);}
.fls-stp-val{width:52px;text-align:center;background:transparent;border:none;border-left:1px solid var(--border);border-right:1px solid var(--border);color:#fff;font-size:0.95rem;font-weight:600;height:42px;font-family:'DM Sans',sans-serif;}
.fls-btn-gold{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:13px 24px;background:linear-gradient(135deg,var(--gold),var(--gold2));color:var(--navy);border:none;border-radius:10px;font-family:'DM Sans',sans-serif;font-size:0.95rem;font-weight:700;cursor:pointer;transition:transform 0.2s,box-shadow 0.2s;box-shadow:0 6px 24px rgba(245,166,35,0.3);margin-bottom:10px;}
.fls-btn-gold:hover{transform:translateY(-2px);box-shadow:0 10px 32px rgba(245,166,35,0.4);}
.fls-btn-sec{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:12px 24px;background:rgba(255,255,255,0.06);color:rgba(255,255,255,0.8);border:1px solid rgba(255,255,255,0.14);border-radius:10px;font-family:'DM Sans',sans-serif;font-size:0.9rem;font-weight:600;cursor:pointer;transition:background 0.2s,transform 0.2s;}
.fls-btn-sec:hover{background:rgba(255,255,255,0.12);transform:translateY(-2px);}
.fls-feats{padding:72px 5%;background:rgba(6,17,43,0.5);border-top:1px solid var(--border);border-bottom:1px solid var(--border);position:relative;z-index:1;}
.fls-feats-inner{max-width:1100px;margin:0 auto;}
.fls-feats-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:18px;margin-top:36px;}
.fls-feat{background:rgba(255,255,255,0.03);border:1px solid var(--border);border-radius:18px;padding:22px;transition:border-color 0.3s,transform 0.3s;position:relative;overflow:hidden;}
.fls-feat::before{content:'';position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,var(--blue),var(--blue3));transform:scaleX(0);transform-origin:left;transition:transform 0.3s;}
.fls-feat:hover{border-color:rgba(28,115,186,0.35);transform:translateY(-4px);}
.fls-feat:hover::before{transform:scaleX(1);}
.fls-feat-icon{font-size:26px;margin-bottom:10px;display:block;}
.fls-feat-title{font-family:'Clash Display',sans-serif;font-size:0.95rem;font-weight:600;color:#fff;margin-bottom:5px;}
.fls-feat-desc{font-size:0.82rem;color:rgba(255,255,255,0.5);line-height:1.6;}
.fls-reviews{padding:72px 5%;position:relative;z-index:1;}
.fls-reviews-inner{max-width:1100px;margin:0 auto;}
.fls-reviews-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(280px,1fr));gap:18px;margin-top:36px;}
.fls-review{background:rgba(255,255,255,0.03);border:1px solid var(--border);border-radius:18px;padding:22px;}
.fls-review-stars{color:var(--gold);font-size:14px;margin-bottom:10px;letter-spacing:2px;}
.fls-review-text{font-size:0.88rem;color:rgba(255,255,255,0.7);line-height:1.65;margin-bottom:14px;}
.fls-review-name{font-size:0.8rem;font-weight:700;color:#fff;}
.fls-review-date{font-size:0.72rem;color:var(--muted);margin-top:2px;}
.fls-modal-overlay{position:fixed;inset:0;z-index:200;background:rgba(6,17,43,0.88);backdrop-filter:blur(12px);display:flex;align-items:center;justify-content:center;padding:24px;}
.fls-modal{background:linear-gradient(145deg,var(--navy2),var(--navy3));border:1px solid rgba(28,115,186,0.3);border-radius:24px;padding:36px;max-width:480px;width:100%;box-shadow:0 24px 80px rgba(0,0,0,0.6);position:relative;}
.fls-modal-close{position:absolute;top:16px;right:16px;width:32px;height:32px;border-radius:50%;background:rgba(255,255,255,0.08);border:none;color:rgba(255,255,255,0.6);font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background 0.2s;}
.fls-modal-close:hover{background:rgba(255,255,255,0.15);color:#fff;}
.fls-demo-scene{display:flex;align-items:center;justify-content:center;gap:28px;padding:20px 0;}
.fls-demo-stand{width:110px;height:80px;border-radius:10px;object-fit:contain;border:2px solid var(--border);}
.fls-demo-phone{width:130px;height:250px;background:#0a0a0a;border-radius:20px;border:2px solid #333;overflow:hidden;display:flex;flex-direction:column;box-shadow:0 16px 40px rgba(0,0,0,0.6);}
.fls-demo-bar{height:26px;background:#111;display:flex;align-items:center;justify-content:center;}
.fls-demo-notch{width:44px;height:7px;background:#222;border-radius:99px;}
.fls-demo-screen{flex:1;background:#0d1f45;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:8px;gap:6px;}
.fls-demo-msg{font-size:9px;color:var(--blue3);text-align:center;font-weight:600;animation:flsFadePulse 1s infinite;}
@keyframes flsFadePulse{0%,100%{opacity:1}50%{opacity:0.4}}
.fls-demo-profile{display:flex;flex-direction:column;align-items:center;gap:4px;width:100%;}
.fls-demo-avatar{width:36px;height:36px;border-radius:50%;background:linear-gradient(135deg,var(--blue),var(--blue3));display:flex;align-items:center;justify-content:center;font-size:14px;color:#fff;font-weight:700;}
.fls-demo-name{font-size:8px;color:#fff;font-weight:700;}
.fls-demo-role{font-size:7px;color:var(--muted);}
.fls-demo-chips{display:flex;gap:3px;flex-wrap:wrap;justify-content:center;}
.fls-demo-chip{font-size:6px;padding:2px 5px;border-radius:99px;background:rgba(28,115,186,0.2);color:var(--blue3);border:1px solid rgba(28,115,186,0.3);}
.fls-toast{position:fixed;bottom:28px;left:50%;transform:translateX(-50%);background:rgba(13,31,69,0.97);color:#fff;border:1px solid var(--border);border-radius:10px;padding:12px 22px;font-size:0.85rem;font-weight:600;z-index:300;box-shadow:0 8px 32px rgba(0,0,0,0.4);animation:flsToastUp 0.3s ease;}
@keyframes flsToastUp{from{transform:translateX(-50%) translateY(10px);opacity:0;}}
`;

const MATS = [
  { key:'acrylic', label:'Acrylic', price:2999, img:'/images/flapStand_acrylic.png' },
  { key:'wood',    label:'Wood',    price:3999, img:'/images/flapStand_wood.png'    },
];
const FEATURES = [
  { icon:'📡', title:'Dynamic QR',      desc:'QR code updates in real-time — change the destination anytime without reprinting.' },
  { icon:'🏢', title:'Desk-Ready',      desc:'Acrylic stand keeps your QR visible and elegant on any desk or reception counter.' },
  { icon:'🌿', title:'Eco-Friendly',    desc:'Choose wood for a sustainable, premium option that leaves a lasting impression.' },
  { icon:'🔗', title:'Flap Integrated', desc:'Links directly to your Flap profile, business page, menu, or any URL.' },
  { icon:'📊', title:'Scan Analytics',  desc:'Track how many times your QR is scanned from your Flap dashboard.' },
];
const REVIEWS = [
  { name:'Priya Sharma',  rating:5, text:'The acrylic stand is stylish and works perfectly with my Flap Card!',     date:'Aug 2025' },
  { name:'Ravi Kumar',    rating:5, text:'Wooden version feels premium — QR updates are seamless. Great product!', date:'Aug 2025' },
  { name:'Anita Desai',   rating:4, text:'Setup was quick, the stand looks amazing on my office desk.',             date:'Sep 2025' },
];
const fmt = n => `Rs. ${n.toLocaleString('en-IN')}`;
const stars = n => '★'.repeat(Math.round(n)) + '☆'.repeat(5-Math.round(n));

export default function FlapStand() {
  const [mat,      setMat]      = useState('acrylic');
  const [qty,      setQty]      = useState(1);
  const [toast,    setToast]    = useState('');
  const [demo,     setDemo]     = useState(false);
  const [demoStep, setDemoStep] = useState(0);

  const selected = MATS.find(m => m.key === mat);
  const showToast = msg => { setToast(msg); setTimeout(() => setToast(''), 2800); };

  const handleOrder = () => {
    showToast('Opening WhatsApp…');
    const msg = `Hi! I'd like to order ${qty} Flap Stand (${selected.label}) at ${fmt(selected.price)} each. Total: ${fmt(qty * selected.price)}.`;
    setTimeout(() => window.open(`https://wa.me/9779802365432?text=${encodeURIComponent(msg)}`, '_blank'), 900);
  };

  const handleDemo = () => {
    setDemo(true); setDemoStep(1);
    setTimeout(() => setDemoStep(2), 800);
    setTimeout(() => setDemoStep(3), 1600);
  };

  return (
    <div className="fls-page">
      <style>{STYLES}</style>
      <nav className="fls-nav">
        <a href="/" className="fls-logo">flap<span>.</span></a>
        <a href="/" className="fls-back">← Back to home</a>
      </nav>

      {/* Hero */}
      <section className="fls-hero">
        <div>
          <div className="fls-eyebrow"><span className="fls-eyebrow-dot"/>NFC Product · {fmt(selected.price)}</div>
          <h1 className="fls-h1">Flap <em>Stand</em></h1>
          <p className="fls-sub">Dynamic QR code display for desks, counters, and events. Update the content behind your QR anytime — no reprinting, ever.</p>
          <div style={{ display:'flex', gap:12, flexWrap:'wrap' }}>
            <button className="fls-btn-gold" style={{ width:'auto', padding:'11px 28px' }} onClick={handleOrder}>
              Order Now — {fmt(selected.price)}
            </button>
            <button className="fls-btn-sec" style={{ width:'auto', padding:'11px 28px' }} onClick={handleDemo}>
              ▶ See Demo
            </button>
          </div>
        </div>
        <div className="fls-img-wrap">
          <img src={selected.img} alt={`Flap Stand ${selected.label}`} className="fls-img"/>
        </div>
      </section>

      {/* Body */}
      <div className="fls-body">
        <div className="fls-grid">
          {/* Left: material preview thumbnails */}
          <div>
            <span className="fls-section-label">Material Options</span>
            <h2 className="fls-section-heading">Choose your <em>finish</em></h2>
            <div style={{ display:'flex', gap:14, marginTop:20, flexWrap:'wrap' }}>
              {MATS.map(m => (
                <div key={m.key}
                  onClick={() => setMat(m.key)}
                  style={{
                    border: `2px solid ${mat===m.key ? 'var(--blue3)' : 'var(--border)'}`,
                    borderRadius: 16, padding:14, cursor:'pointer',
                    background: mat===m.key ? 'rgba(28,115,186,0.1)' : 'rgba(255,255,255,0.02)',
                    transition: 'all 0.2s', minWidth: 160,
                  }}>
                  <img src={m.img} alt={m.label}
                    style={{ width:'100%', height:100, objectFit:'contain', marginBottom:10 }}/>
                  <div style={{ fontFamily:"'Clash Display',sans-serif", fontWeight:700, fontSize:'0.95rem', color:'#fff', marginBottom:2 }}>
                    {m.label}
                  </div>
                  <div style={{ fontSize:'0.82rem', color:'var(--gold)', fontWeight:600 }}>{fmt(m.price)}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: order */}
          <div className="fls-order">
            <span className="fls-section-label">Order</span>
            <div className="fls-price">{fmt(selected.price)}</div>
            <div className="fls-price-sub">Flap Stand · {selected.label} · free delivery in KTM</div>

            <div style={{ fontSize:'0.72rem', fontWeight:700, color:'var(--muted)', textTransform:'uppercase', letterSpacing:1.5, marginBottom:8 }}>Material</div>
            <div className="fls-mat-row">
              {MATS.map(m => (
                <button key={m.key} className={`fls-mat-btn ${mat===m.key?'active':''}`} onClick={()=>setMat(m.key)}>
                  {m.label} — {fmt(m.price)}
                </button>
              ))}
            </div>

            <div style={{ fontSize:'0.72rem', fontWeight:700, color:'var(--muted)', textTransform:'uppercase', letterSpacing:1.5, marginBottom:8 }}>Quantity</div>
            <div className="fls-stepper">
              <button className="fls-stp-btn" onClick={()=>setQty(q=>Math.max(1,q-1))}>−</button>
              <input className="fls-stp-val" type="number" value={qty} min="1" onChange={e=>setQty(Math.max(1,+e.target.value))}/>
              <button className="fls-stp-btn" onClick={()=>setQty(q=>q+1)}>+</button>
            </div>
            <div style={{ fontSize:'0.8rem', color:'var(--muted)', marginBottom:20 }}>
              Total: <strong style={{color:'var(--gold)'}}>{fmt(qty * selected.price)}</strong>
            </div>

            <button className="fls-btn-gold" onClick={handleOrder}>📱 Order via WhatsApp</button>
            <button className="fls-btn-sec" onClick={handleDemo}>▶ View Demo</button>

            <div style={{ marginTop:22, paddingTop:18, borderTop:'1px solid rgba(255,255,255,0.07)' }}>
              <div style={{ fontSize:'0.72rem', color:'var(--muted)', textTransform:'uppercase', letterSpacing:1.5, marginBottom:10 }}>Includes</div>
              {['Dynamic QR configured','Flap dashboard access','Unlimited URL updates','Desk stand + NFC tag'].map(i=>(
                <div key={i} style={{ display:'flex', gap:8, alignItems:'center', marginBottom:7 }}>
                  <span style={{ color:'var(--gold)', fontSize:12 }}>✓</span>
                  <span style={{ fontSize:'0.82rem', color:'rgba(255,255,255,0.6)' }}>{i}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Features */}
      <section className="fls-feats">
        <div className="fls-feats-inner">
          <span className="fls-section-label">Features</span>
          <h2 className="fls-section-heading">Everything a stand <em>should do</em></h2>
          <div className="fls-feats-grid">
            {FEATURES.map(f=>(
              <div className="fls-feat" key={f.title}>
                <span className="fls-feat-icon">{f.icon}</span>
                <div className="fls-feat-title">{f.title}</div>
                <div className="fls-feat-desc">{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Reviews */}
      <section className="fls-reviews">
        <div className="fls-reviews-inner">
          <span className="fls-section-label">Reviews</span>
          <h2 className="fls-section-heading">What customers <em>say</em></h2>
          <div className="fls-reviews-grid">
            {REVIEWS.map(r=>(
              <div className="fls-review" key={r.name}>
                <div className="fls-review-stars">{stars(r.rating)}</div>
                <p className="fls-review-text">"{r.text}"</p>
                <div className="fls-review-name">{r.name}</div>
                <div className="fls-review-date">{r.date}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Demo modal */}
      {demo && (
        <div className="fls-modal-overlay" onClick={e=>{ if(e.target===e.currentTarget){setDemo(false);setDemoStep(0);}}}>
          <div className="fls-modal">
            <button className="fls-modal-close" onClick={()=>{setDemo(false);setDemoStep(0);}}>✕</button>
            <h3 style={{ fontFamily:"'Clash Display',sans-serif", fontSize:'1.25rem', fontWeight:700, color:'#fff', marginBottom:6 }}>Scan & Connect</h3>
            <p style={{ fontSize:'0.82rem', color:'var(--muted)', marginBottom:20 }}>A customer scans the QR on your Flap Stand and sees your business page instantly.</p>
            <div className="fls-demo-scene">
              <img src={selected.img} alt="Stand" className="fls-demo-stand"/>
              <div style={{ fontSize:20, color:'var(--blue3)', animation:demoStep>=2?'flsFadePulse 0.8s 2':'none' }}>→</div>
              <div className="fls-demo-phone">
                <div className="fls-demo-bar"><div className="fls-demo-notch"/></div>
                <div className="fls-demo-screen">
                  {demoStep===1 && <div className="fls-demo-msg">📷 Scanning QR…</div>}
                  {demoStep===2 && <div className="fls-demo-msg">✅ QR Scanned!</div>}
                  {demoStep>=3 && (
                    <div className="fls-demo-profile">
                      <div className="fls-demo-avatar">🏢</div>
                      <div className="fls-demo-name">Your Business</div>
                      <div className="fls-demo-role">flap.com.np/yourbiz</div>
                      <div className="fls-demo-chips">
                        {['Menu','Contact','Map'].map(l=><span key={l} className="fls-demo-chip">{l}</span>)}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {demoStep>=3
              ? <button className="fls-btn-gold" style={{ marginTop:16 }} onClick={handleOrder}>Order Now — {fmt(selected.price)}</button>
              : <button className="fls-btn-sec" style={{ marginTop:16 }} onClick={handleDemo}>▶ Restart</button>
            }
          </div>
        </div>
      )}

      {toast && <div className="fls-toast">{toast}</div>}
    </div>
  );
}